import React, {Component} from 'react';
import EpicMenu from '../componentes/Menus/EpicMenu';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Pendientes from '../componentes/Pendientes';
import NuevoPendiente from '../componentes/nuevoPendiente/nuevoPendiente';
import { Icon, Modal } from 'semantic-ui-react';
import formStyles from '../componentes/forms/form.module.css';

class PPendientes extends Component{
	constructor(props){
		super(props);
		this.app= firebase;
		this.database = this.app.firestore().collection('Tareas')
		this.state = {
			trabajos: [],
			actividades:{},
			useModal: false,
		}
		this.getActividades()
	}

	componentDidMount(){
		this.database.orderBy('fechaFin').where("status", "==", "pendiente").onSnapshot(querySnapshot =>{
			this.setState({trabajos:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.trabajos;
				previousAct.push({
					id: doc.id,
					actividad: doc.data().actividad,
					descripcion: doc.data().descripcion,
					fechaInicio: doc.data().fechaInicio,
					fechaFin: doc.data().fechaFin,
					lugarPendiente: doc.data().lugarPendiente.split(",").sort().join(),
					lugarCompletado:doc.data().lugarCompletado.split(",").sort().join(),
					zona:doc.data().zona,
					tunel:doc.data().tunel,
					tipoPago: doc.data().tipoPago,
					personas: doc.data().personas,
					status: doc.data().status,
				})
				this.setState({
					trabajos: previousAct
				})
			})
		})
	}
	getActividades=()=>{
		firebase.firestore().collection('Actividades').get()
		.then(actividades=>{
			actividades.forEach(doc=>{
				const actividades=this.state.actividades
				actividades[doc.data().nombre]=doc.data().pagarpor
				this.setState({actividades:actividades})
			})
		})
	}
	addAct=(trabajo)=>{
		this.database.add({
			fechaInicio: trabajo.fechaInicio,
			fechaFin: trabajo.fechaFin,
			actividad: trabajo.actividad,
			descripcion: trabajo.descripcion,
			lugarPendiente: trabajo.lugarPendiente,
			lugarCompletado:trabajo.lugarCompletado,
			status: "pendiente",
		});
	}
	terminarPendiente=(trabajoID, personas)=>{
		this.database.doc(trabajoID).update({
			personas: personas,
			status: "hecha",
		})
	}
	ocultarPendiente=(trabajoID)=>{
		this.database.doc(trabajoID).update({
			status: "hecha",
		})
	}
	modalAgregar = () => (
		<Modal
			className={formStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo Pendiente</button>}>
			<Modal.Header>Agregar tarea pendiente</Modal.Header>
			<Modal.Content>
				<NuevoPendiente addAct={this.addAct} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	TablaPendientes = () => {
		return (
		<div className="body tabla pendientesTabla">
			<table><tbody>
				<tr>
					<th>Actividad</th>
					<th>Descripcion</th>
					{/*<th>Fecha limite</th>*/}
					<th>Dias Faltantes</th>
					<th>Área</th>
					<th>Área Completada</th>
					<th></th>
				</tr>
				{
					this.state.trabajos.map((trabajo) => {
						return (
							<tr key={trabajo.id}><Pendientes    
								actividad={trabajo.actividad}
								actividades={this.state.actividades}
								descripcion={trabajo.descripcion}
								fechaInicio={trabajo.fechaInicio}
								fechaFin={trabajo.fechaFin}
								lugarPendiente={trabajo.lugarPendiente}
								lugarCompletado={trabajo.lugarCompletado}
								tipoPago={trabajo.tipoPago}
								personas={trabajo.personas}
								trabajoID={trabajo.id} 
								key={trabajo.id} 
								terminarPendiente ={this.terminarPendiente}
								ocultarPendiente ={this.ocultarPendiente}
							/></tr>
						)
					})
				} 
			</tbody></table>
		</div>
		)
	}
	NoPendientes = () => {
	return(
		<div>No hay pendintes.</div>
	)
	}
	render(){
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>Pendientes</div>
				<div className="addNew" ><this.modalAgregar /></div>
			</div>
			{this.state.trabajos ? <this.TablaPendientes />: <this.NoPendientes />}
			<div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
		</div>
		)
	}
}

export default PPendientes;
